import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import { Sucursal } from '../sucursal/sucursal';
import { Usuario } from './usuario';

import myGlobals = require('../config');

@Injectable()
export class UsuariosService {

  private usuarioUrl = myGlobals.default.BASE_URL+'/usuarios/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todas los usuarios
  getUsuarios() {
    return this.http.get(this.usuarioUrl)
               .map((response) => response.json());
  }

  //Obtener un usuario
  getUsuario(_id: string): Observable<Usuario>  {
    return this.http.get(this.usuarioUrl+_id)
               .map((response) => response.json());
  }

  //Obtener un usuario by sucursal
  getUsuarioBySucursal(_idSucursal: string): Observable<Usuario[]> {
    return this.http.get(this.usuarioUrl +"sucursal/"+ _idSucursal)
      .map((response) => response.json());
  }


  getUsuarioByNickname(usuario: string): Observable<Usuario>  {
    return this.http.get(this.usuarioUrl+usuario)
               .map((response) => response.json());
  }

  save(usuario: Usuario): Observable<Usuario>  {
    if (usuario._id) {
      return this.put(usuario);
    }
    //Seteo estado activo
    usuario.estado=true;
    return this.post(usuario);
  }

  //Desactivar usuario
  delete(usuario: Usuario) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.usuarioUrl}/${usuario._id}`;

    return this.http
               .delete(url, {headers: headers})
               .map((response) => response.json());
  }

  // Agregar nuevo usuario
  private post(usuario: Usuario):Observable<Usuario> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'});
    headers.append('dataType', 'json');
    var usuarioStr=JSON.stringify(usuario);
    return this.http
               .post(this.usuarioUrl, usuarioStr, {headers: headers})
                .map((response) => response.json());
  }

  // Actualizar usuario
  private put(usuario: Usuario) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.usuarioUrl}/${usuario._id}`;

    return this.http
               .put(url, JSON.stringify(usuario), {headers: headers})
               .map((response) => response.json());
  }

  cambiarPassword(usuario: Usuario): Observable<Usuario>  {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.usuarioUrl}cambiarPassword/${usuario._id}`;

    return this.http
        .put(url, JSON.stringify(usuario), {headers: headers})
        .map((response) => response.json());
  }

  probarCelular(celular)  {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.usuarioUrl}probarCelular/`;
    var usuarioStr=JSON.stringify({celular: celular});
    return this.http
        .post(url, usuarioStr, {headers: headers})
        .map((response) => response.json());
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/usuarios/usuario.service.ts